import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

/* Ombres quasi nulles, séparations par filets de 1 px (arbitrage n°14). */
export function Carte({ className, ...reste }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("rounded-[6px] border border-filet bg-white", className)} {...reste} />;
}

export function EnTeteCarte({ className, ...reste }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("border-b border-filet px-4 py-3", className)} {...reste} />;
}

export function CorpsCarte({ className, ...reste }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("px-4 py-3", className)} {...reste} />;
}
